<template>
  <canvas id="filePreview" style="display:block;margin: 0 auto" />
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'ImagePreview',
  props: {
    imageInfo: {
      type: Object,
      default: () => ({})
    },
    curFocus: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      ctx: null,
      proportion: 1,
      img: null
    }
  },
  watch: {
    imageInfo(val) {
      if (val) {
        this.init(val)
      }
    },
    curFocus(val, oldVal) {
      this.drawMain(this.imageInfo)
      if (val !== oldVal && val in this.imageInfo) {
        const { left, right, top, bottom } = this.imageInfo[val]
        this.preRect = [left * this.proportion, top * this.proportion, Math.abs(left * this.proportion - right * this.proportion), Math.abs(top * this.proportion - bottom * this.proportion)]
        this.ctx.strokeStyle = 'red'
        this.ctx.strokeRect(...this.preRect)
      }
    }
  },
  mounted() {
    this.init(this.imageInfo)
  },
  methods: {
    async init(imageInfo) {
      const loading = getLoading('intelligent-booking-result-dialog')
      const { imgPath } = imageInfo
      this.img = new Image()
      this.img.onload = () => {
        this.drawMain(imageInfo)
        loading.close()
      }
      this.img.onerror = () => {
        this.$message.error(this.$t('SeaExport.PictureLoadingFailed'))
        loading.close()
      }
      let imgSrc = ''
      if (imgPath.indexOf('http') < 0) {
        imgSrc = 'http:' + imgPath
      } else {
        imgSrc = imgPath
      }
      await cache.load(cacheName.CONFIG)
      const mapping = cache.config.get('IntelligentBookingImgUrlMapping')
      if (mapping) {
        // 参数格式http://222.92.117.100:37047;https://imgress.cargoware.com
        const urlArray = mapping.split(';')
        if (urlArray && urlArray.length === 2 && urlArray[0] && urlArray[1]) {
          // 原域名
          const sourceUrl = urlArray[0].split(',')
          // 目标域名
          const targetUrl = urlArray[1]
          for (const url of sourceUrl) {
            if (imgSrc.indexOf(url) >= 0) {
              imgSrc = imgSrc.replace(url, targetUrl)
              break
            }
          }
        }
      }
      this.img.src = imgSrc
    },
    drawMain(imageInfo) {
      const canvas = document.getElementById('filePreview')
      const { width, height } = imageInfo
      const newWidth = document.body.clientWidth / 2 < 800 ? 800 : document.body.clientWidth / 2
      this.proportion = newWidth / width
      const newHeight = height * this.proportion
      canvas.width = newWidth
      canvas.height = newHeight
      this.ctx = canvas.getContext('2d')
      this.ctx.drawImage(this.img, 0, 0, this.img.width, this.img.height, 0, 0, newWidth, newHeight)
    }
  }
}
</script>

<style scoped>

</style>
